import { FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export const EMAIL_LIST_SEPARATOR = ';';

export function getEmailListEntries(emails: string[]): string[] {
	return (emails ?? []).map(e => e?.trim()).filter(Boolean);
}

/**
 * Validates a `FormArray` of email inputs that is stored as a single semicolon-separated value.
 * Each entry is validated separately by its own control.
 */
export function emailListValidator(options: { required?: boolean; maxLength?: number } = {}): ValidatorFn {
	return (formArray: FormArray): ValidationErrors | null => {
		const emails = getEmailListEntries(formArray.value);

		if (options.required && !emails.length) {
			return { required: true };
		}

		if (options.maxLength && emails.join(EMAIL_LIST_SEPARATOR).length > options.maxLength) {
			return { maxTotalLength: { requiredLength: options.maxLength } };
		}

		if (emails.length !== new Set(emails.map(e => e.toLowerCase())).size) {
			return { duplicateEmail: true };
		}

		return null;
	};
}
